var DOC = document;
var WIN = window;

var __DropDown = {

	elements: [],

	instances: [],

	isDisplayType: function (type) {
		var types = ['flex', 'block', 'inline-block', 'grid', 'table', 'inline-table', 'inline-flex', 'inline-grid'];

		if (typeof type !== 'string') {
			return false;
		}

		return types.indexOf(type.toLowerCase()) >= 0;

	}

};

var DropDownInitializer = function (el, options) {

	let b = 0;

	var __obj;

	var CORE = {

		$el: $(el),

		onObjects: function (els, callback) {
			var i = 0;

			if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
				return false;
			}

			if (typeof callback !== 'function') {
				return false;
			}

			for (i; i < els.length; i++) {

				if (typeof els[i] !== 'object' || els[i] == null) {
					continue;
				}
				callback(els[i]);

			}
			return true;

		},

		closeAll: function (instance) {
			instance.close();
		},

		height: function () {
			var height, buttonHeight, contentHeight;

			if (!options.tabs) {
				return;
			}
			height = null;

			if (CORE.$el.hasClass(options.classNames.holder + '--active')) {
				height = 0;

				CORE.onObjects(CORE.button.elements, function (that) {
					height = height + that.offsetHeight;

				});

				CORE.onObjects(CORE.dropdown.elements, function (that) {
					height = height + that.offsetHeight;

				});

				height = height > 0 ? height + 'px' : null;

			}
			el.style.height = height;

		},

		button: {

			elements: null,

			onClick: function (e) {

				if (this.nodeName === 'A') {
					e.preventDefault();
				}

				CORE.dropdown.toggle();

				if ('onButton' in options && typeof options.onButton === 'function') {
					options.onButton({
						holder: el,
						button: CORE.button.elements,
						dropdown: CORE.dropdown.elements,
						opened: CORE.dropdown.open,
						target: this
					});
				}

			},

			construct: function () {
				var els = el.getElementsByClassName(options.classNames.button);
				var i = 0;

				if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
					return false;
				}
				CORE.button.elements = [];

				for (i; i < els.length; i++) {
					CORE.button.elements[CORE.button.elements.length] = els[i];
					els[i].addEventListener('click', CORE.button.onClick);

				}

			}

		},

		close: {

			elements: null,

			onClick: function (e) {

				e.preventDefault();

				CORE.dropdown.close();

			},

			construct: function () {
				var els = el.getElementsByClassName(options.classNames.close);
				var i = 0;

				if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
					return false;
				}
				CORE.close.elements = [];

				for (i; i < els.length; i++) {
					CORE.close.elements[CORE.close.elements.length] = els[i];
					els[i].addEventListener('click', CORE.close.onClick);

				}

			}

		},

		dropdown: {

			elements: null,

			open: false,

			close: function () {
				CORE.$el.removeClass(options.classNames.holder + '--active');
				CORE.dropdown.open = false;

				if (options.tabs) {
					el.style.height = null;
				}

			},

			toggle: function () {
				const isOpen = CORE.$el.hasClass(options.classNames.holder + '--active');
				let i = 0;
				var insts = [];

				CORE.$el.removeClass(options.classNames.holder + '--active');

				if (options.closeAll && __DropDown.instances.length) {
					for (i; i < __DropDown.instances.length; i++){
						if (__DropDown.instances[i].$element.hasClass(options.classNames.holder)) {
							insts[insts.length] = __DropDown.instances[i];
						}
					}

					if (insts.length) {
						// CORE.onObjects(__DropDown.instances, CORE.closeAll);
						CORE.onObjects(insts, CORE.closeAll);
					}
				}

				if (isOpen && !options.tabs) {
					CORE.dropdown.open = false;
					return;
				}
				CORE.$el.addClass(options.classNames.holder + '--active');
				CORE.dropdown.open = true;
				CORE.height();

			},

			construct: function () {
				var els = el.getElementsByClassName(options.classNames.dropdown);
				var i = 0;

				if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
					return false;
				}
				CORE.dropdown.elements = [];

				for (i; i < els.length; i++) {
					CORE.dropdown.elements[CORE.dropdown.elements.length] = els[i];
					// els[i].style.display = 'none';
				}

			},

			destroy: function () {
				// todo

			}
		}

	};

	if (__DropDown.elements.length) {
		for (b; b < __DropDown.elements.length; b++){
			if (__DropDown.elements[b] === el) {
				return false;
			}
		}
	}

	CORE.button.construct();
	CORE.close.construct();
	CORE.dropdown.construct();
	CORE.height();

	if (options.tabs) {
		WIN.addEventListener('resize', CORE.height);
	}

	__obj = {
		// buttons: CORE.button.elements,
		// dropdowns: CORE.dropdown.elements,
		element: el,
		$element: CORE.$el,
		destroy: CORE.destroy,
		close: CORE.dropdown.close
	};

	__DropDown.elements[__DropDown.elements.length] = el;
	__DropDown.instances[__DropDown.instances.length] = __obj;

	return __obj;
}

var DropDown = function (options) {
	var els;
	var i = 0;
	var parentNode = DOC;

	if (typeof options !== 'object' || options == null) {
		options = {};
	}
	options.prefix = 'prefix' in options && typeof options.prefix === 'string' ? options.prefix : 'dropdown';
	options.display = 'display' in options && __DropDown.isDisplayType(options.display) ? options.display : 'block';
	options.closeAll = 'closeAll' in options && typeof options.closeAll === 'boolean' ? options.closeAll : true;
	options.tabs = 'tabs' in options && typeof options.tabs === 'boolean' ? options.tabs : false;
	options.classNames = {
		holder: options.prefix + '--holder',
		button: options.prefix + '__button',
		close: options.prefix + '__close',
		dropdown: options.prefix + '__content',
	};

	if ('parentNode' in options && typeof options.parentNode === 'object' && options.parentNode !== null && 'nodeName' in options.parentNode) {
		parentNode = options.parentNode;
	}
	els = parentNode.getElementsByClassName(options.classNames.holder);

	if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
		return false;
	}

	for (i; i < els.length; i++) {
		DropDownInitializer(els[i], options);

	}

	return {

		refresh: function () {
			DropDown(options);

		}

	};

};

export default DropDown;